import { Component, Inject } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { SharedModule } from '../../../_shared/shared.module';
import { AbilityService } from '../../../_shared/services/ability.service';
import { SessionService } from '../../../_shared/services/session.service';
import { UtilService } from '../../../_shared/services/util.service';

import { LanguageService } from '../../../languages/shared/language.service';

import { Season } from '../../shared/season.model';
import { SeasonService } from '../../shared/season.service';
import { SeasonListComponent } from '../../season-list/season-list.component';
import { SeasonDetailComponent } from '../../season-detail/season-detail.component';

@Component({
  selector: 'app-seasons-modal',
  templateUrl: './seasons-modal.component.html',
  standalone: true,
  imports: [SharedModule, SeasonListComponent, SeasonDetailComponent],
})
export class SeasonsModalComponent {
  constructor(
    private seasonService: SeasonService,
    private languageService: LanguageService,
    private abilityService: AbilityService,
    private sessionService: SessionService,
    private utilService: UtilService,
    private ref: MatDialogRef<SeasonsModalComponent>,
    @Inject(MAT_DIALOG_DATA) private data
  ) {
    // use it onInit ??
    this.getAdditionalLanguages();
  }

  // @Output() private dialogSaved = new EventEmitter<any>(); // avoid closing the dialog

  modalTitle = this.data.title;
  // lang = this.data.params.lang;

  seasons: Season[];
  meta = [];
  season: Season;
  mode = '';
  loadingSeasons = false;

  listMode = true;
  detailMode = false;

  permissions = {
    canList: this.abilityService.can('index_season_accountadmin'),
    canCreate: this.abilityService.can('create_season_accountadmin'),
  };

  defaultLanguage: any;
  additionalLanguages = [];

  private filterCriteria = this.seasonService.getFilterCriteria();

  showSeasons() {
    this.modalTitle = this.data.title;

    this.listMode = true;
    this.detailMode = false;

    this.getSeasons();
  }

  addSeason() {
    this.modalTitle = 'ADD_SEASON';
    this.listMode = false;
    this.detailMode = true;

    this.season = {};
  }

  // Referenced from app-season-detail
  onSavedSeason(season) {
    this.season = season;

    this.listMode = true;
    this.detailMode = false;

    this.getSeasons(season);
  }

  // Referenced from app-season-detail
  onCanceledSeason() {
    this.showSeasons();
  }

  close() {
    this.ref.close(true);
  }

  // Referenced from app-season-list
  onSelectedSeason({ season, mode = '' }) {
    this.season = season;
    this.mode = mode;

    this.modalTitle = 'SEASON_DETAILS';
    this.listMode = false;
    this.detailMode = true;
  }

  private getSeasons(selectedSeason = null) {
    this.filterCriteria.lang = this.sessionService.getUserLanguage().code;
    this.filterCriteria.by_current_seasons = 'current';
    // this.filterCriteria['skip_check_role'] = true;

    this.loadingSeasons = true;
    this.seasonService.getSeasons(this.filterCriteria).subscribe((response) => {
      this.seasons = response.data;
      this.meta = response.meta;

      this.loadingSeasons = false;

      if (selectedSeason) {
        this.utilService.changeItemRowStyle(selectedSeason.id);
      }
    });
  }

  private getAdditionalLanguages() {
    this.languageService.getLanguages({ skip_check_role: true }).subscribe((response) => {
      this.defaultLanguage = response.data.find((language) => language.is_default);
      this.additionalLanguages = response.data.filter((language) => !language.is_default);

      this.getSeasons();
    });
  }
}
